import { render, staticRenderFns } from "./navegacao-v2-sidebar.vue?vue&type=template&id=3b103422&"
import script from "./navegacao-v2-sidebar.vue?vue&type=script&lang=js&"
export * from "./navegacao-v2-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b103422')) {
      api.createRecord('3b103422', component.options)
    } else {
      api.reload('3b103422', component.options)
    }
    module.hot.accept("./navegacao-v2-sidebar.vue?vue&type=template&id=3b103422&", function () {
      api.rerender('3b103422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/navegacao-v2-sidebar.vue"
export default component.exports